import React from 'react'
import { withRouter } from 'react-router-dom'

import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { RadioButton } from 'primereact/radiobutton';
import { Button } from 'primereact/button'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { OverlayPanel } from 'primereact/overlaypanel';
import { InputText } from 'primereact/inputtext'
import { Tooltip } from 'primereact/tooltip';
import { Tag } from 'primereact/tag';
import { Badge } from 'primereact/badge';
import { Checkbox } from 'primereact/checkbox';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import NavBar from '../../componentes/Navbar'
import Progresso from '../../componentes/Progresso'
import warning from '../../img/warning3.jpg'

import LocalStorageService from '../../app/service/localStorageService'
import ProcessoService from '../../app/service/ProcessoService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import TipoAcaoService from '../../app/service/TipoAcaoService'
import StatusProcessualService from '../../app/service/StatusProcessualService'
import TipoDecisaoService from '../../app/service/TipoDecisao'
import ProcessoImportanciaService from '../../app/service/ProcessoImportanciaService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './processo.css'
import './processoConsulta.css'

class Processo extends React.Component {

  constructor(props) {
    super(props);

    this.processoService = new ProcessoService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.tipoAcaoService = new TipoAcaoService();
    this.statusProcessualService = new StatusProcessualService();
    this.tipoDecisaoService = new TipoDecisaoService();
    this.processoImportanciaService = new ProcessoImportanciaService();
    this.onGrupoChange = this.onGrupoChange.bind(this);
    this.onTiposAcaoChange = this.onTiposAcaoChange.bind(this);
    this.onTiposDecisaoChange = this.onTiposDecisaoChange.bind(this);
    this.onStatusProcessualChange = this.onStatusProcessualChange.bind(this);
    this.acoes = this.acoes.bind(this);
    this.arquivado = this.arquivado.bind(this);
    this.importante = this.importante.bind(this);
    this.accepExcluirProcesso = this.accepExcluirProcesso.bind(this);
    this.templateConsultaProcesso = this.templateConsultaProcesso.bind(this);
    this.renderFooterExclusao = this.renderFooterExclusao.bind(this);
    this.renderFooterAvisoExclusao = this.renderFooterAvisoExclusao.bind(this);
   
    this.state = {
      processos: [],
      processo: null,
      partes: [],
      //Filtro Processo
      pessoa: '',
      gruposTrabalho: [],
      grupoTrabalho: null,
      tiposAcao: [],
      tipoAcao: null,
      statusProcessuais: [],
      statusProcessual: null,
      tiposDecisao: [],
      tipoDecisao: null,
      pasta: '',
      numeroProcesso: '',
      numeroCnj: '',
      consultaGeral: '',
      visible: false,
      //Fim de Filtro
      classeDiv: 'hide',
      detail: '',
      //Processo Importancia
      iconeImportanteParaMim: '',
      importanteParaMim: false,
      importanteParaEmpresa: false,
      estrategico: false,
      openSpinner: false,
      //Exclusao
      modalExclusao: false,
      tipoExclusao: '',
      codigoProcessoExcluir: '',
      modalAvisoDefinitivo: false,
    };
  }

  carregaCombosConsulta = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.setState({openSpinner: true});
    await this.limparCamposConsulta();
    await this.listarGruposTrabalho(usuarioLogado);
    await this.listarTiposAcao(usuarioLogado.empresa);
    await this.listarStatusProcessual(usuarioLogado.empresa);
    await this.listarTiposDecisao(usuarioLogado.empresa);
    this.setState({openSpinner: false});
  }

  limparCamposConsulta = () => {
    this.setState({
      pessoa: '',
      grupoTrabalho: null,
      tipoAcao: null,
      statusProcessual: null,
      tipoDecisao: null,
      pasta: '',
      numeroProcesso: '',
      numeroCnj: '',
      indice: '',
      importanteParaMim: false,
      importanteParaEmpresa: false,
      estrategico: false
    })
  }

  listarGruposTrabalho = (usuario) => {
    this.grupoTrabalhoService.listarGruposUsuario(usuario.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      });
  }

  listarTiposAcao = (empresa) => {
    this.tipoAcaoService.listarTipoAcao(empresa.codigo)
      .then(response => {
        this.setState({tiposAcao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Ação', life: 4000});
      })
  }

  listarStatusProcessual = (empresa) => {
    this.statusProcessualService.listarStatusProcessual(empresa.codigo)
      .then(response => {
        this.setState({statusProcessuais: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Status Processual', life: 4000});
      })
  }

  listarTiposDecisao = (empresa) => {
    this.tipoDecisaoService.listarTiposDecisao(empresa.codigo)
      .then(response => {
        this.setState({tiposDecisao: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Decisão', life: 4000});
      })
  }

  onGrupoChange(e) {
    this.setState({ grupoTrabalho: e.value });
  }

  onTiposAcaoChange(e) {
    this.setState({ tipoAcao: e.value });
  }

  onStatusProcessualChange(e) {
    this.setState({ statusProcessual: e.value });
  }

  onTiposDecisaoChange(e) {
    this.setState({ tipoDecisao: e.value });
  }

  consultarProcessoPorIndice = async() => {
    //this.setState({classeDiv: "show"});
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    const indice = {
      indice: this.state.indice,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }

    await this.processoService.consultarProcessoPorIndice2(indice)
      .then(response => {
        this.setState({processos: response.data});
        LocalStorageService.adicionarConsulta('_consulta_processo_indice', indice);
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
        this.setState({openSpinner: false});
      });

      this.setState({openSpinner: false});
  }

  listarProcessos = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    const IPM = this.state.importanteParaMim ? 'SIM' : 'NAO';
    const IPE = this.state.importanteParaEmpresa ? 'SIM' : 'NAO';
    const EST = this.state.estrategico ? 'SIM' : 'NAO';
    const filtroProcesso = {
      pessoa: this.state.pessoa,
      grupoTrabalho: this.state.grupoTrabalho,
      tipoAcao: this.state.tipoAcao,
      statusProcessual: this.state.statusProcessual,
      tipoDecisao: this.state.tipoDecisao,
      pasta: this.state.pasta,
      numeroProcesso: this.state.numeroProcesso,
      numeroCnj: this.state.numeroCnj,
      empresa: usuarioLogado.empresa,
      usuario: usuarioLogado.codigo,
      importanteParaMim: IPM,
      importanteParaEmpresa: IPE,
      estrategico: EST
    }

    this.setState({openSpinner: true});
    await this.processoService.listarProcessos(filtroProcesso)
      .then(response => {
        this.setState({processos: response.data});
        LocalStorageService.adicionarConsulta('_consulta_processo_filtro', filtroProcesso);
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
      this.setState({openSpinner: false});
      this.op.hide();
  }

  acoes(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-folder-open" className="p-button-rounded p-button-text" 
                tooltip="Abrir Processo"
                onClick={() => this.editarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Processo"
                onClick={() => this.opcaoExcluir(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  opcaoExcluir = (processo) => {
    this.setState({codigoProcessoExcluir: processo.codigo});
    this.abrirModal('modalExclusao');
  }

  selecionarOpcaoExcluir = async () => {
    if(this.state.tipoExclusao == 'definitivo') {
      const usuarioLogado = this.context.usuarioAutenticado
      if(usuarioLogado.perfil.codigo != 1) {
        this.toast.show({severity:'error', summary: 'Exclusão de Processo', detail:'Usuário não tem permissão para excluir processos em definitivo', life: 4000});
      } else {
        this.abrirModal('modalAvisoDefinitivo');
      }
    } else {
        this.excluirProcesso();
    }
  }

  renderFooterExclusao(name) {
    return (
        <div>
            <Button label="Confirmar" 
                    className="p-button-primary p-button-text"
                    onClick={this.selecionarOpcaoExcluir}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterAvisoExclusao(name) {
    return (
        <div>
            <Button label="Confirmar" 
                    className="p-button-primary p-button-text"
                    onClick={this.excluirDefinitivamente}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  excluirDefinitivamente = async () => {
    this.setState({openSpinner: true});
    await this.processoService.excluirDefinitivamente(this.state.codigoProcessoExcluir)
      .then(response => {
        this.atualizarPosExclusao();
        this.fecharModal('modalAvisoDefinitivo');
        this.fecharModal('modalExclusao');
        this.toast.show({severity:'success', summary: 'Excluaão de Processo', detail:'Processo excluído com sucesso', life: 4000});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Excluaão de Processo', detail:`${error}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  atualizarPosExclusao = async () => {
      const consultaIndice = LocalStorageService.obterConsulta('_consulta_processo_indice');
      const consultaIndiceJson = JSON.parse(consultaIndice);

      const consultaFiltro = LocalStorageService.obterConsulta('_consulta_processo_filtro');
      const consultaFiltroJson = JSON.parse(consultaFiltro);

      this.setState({openSpinner: true});
      if(consultaIndiceJson != null) {
        await this.processoService.consultarProcessoPorIndice2(consultaIndiceJson)
          .then(response => {
            this.setState({processos: response.data});
          }).catch(error => {
            this.setState({openSpinner: false});
            this.setState(error.response.data)
            this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
          });
      }

      if(consultaFiltroJson != null) {
          await this.processoService.listarProcessos(consultaFiltroJson)
          .then(response => {
            this.setState({processos: response.data});
          }).catch(error => {
            this.setState({openSpinner: false});
            this.setState(error.response.data)
            this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
          })
      }
      this.setState({openSpinner: false});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  accepExcluirProcesso() {
    //Verificar se o processo possui atividades
    this.excluirProcesso();
  }

  excluirProcesso = async() => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.setState({openSpinner: true});
    await this.processoService.excluirProcesso({
      codigo: this.state.codigoProcessoExcluir,
      status: 3, // Processo removido para lixeira
      usuario: usuarioLogado
    })
      .then(response => {
        const consultaIndice = LocalStorageService.obterConsulta('_consulta_processo_indice');
        const consultaIndiceJson = JSON.parse(consultaIndice);

        const consultaFiltro = LocalStorageService.obterConsulta('_consulta_processo_filtro');
        const consultaFiltroJson = JSON.parse(consultaFiltro);

        if(consultaIndiceJson != null) {
          this.processoService.consultarProcessoPorIndice2(consultaIndiceJson)
            .then(response => {
              this.setState({processos: response.data});
            }).catch(error => {
              this.setState(error.response.data)
              this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
            });
        }

        if(consultaFiltroJson != null) {
           this.processoService.listarProcessos(consultaFiltroJson)
            .then(response => {
              this.setState({processos: response.data});
            }).catch(error => {
              this.setState(error.response.data)
              this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
            })
        }
        this.fecharModal('modalExclusao');
        this.toast.show({severity:'success', summary: 'Processos', detail:'Processo removido para lixeira com sucesso', life: 4000});
        
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Excluaão de Processo', detail:`${error}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  arquivado(rowData) {
    if(rowData.statusProcessual.descricao == 'Arquivado') {
      return(
        <React.Fragment>
          <Tag className="p-mr-2"  severity="info" value="Arquivado"></Tag>
        </React.Fragment>
      )
    }
  }

  importante(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-star" className={rowData.importanteParaMim}
        style={{width: '29px', height: '26px'}} disabled="true"/>
        &nbsp;&nbsp;&nbsp;
        <Button icon="pi pi-heart" className={rowData.importanteParaEmpresa}
         style={{width: '29px', height: '26px'}} disabled="false"/>
      </React.Fragment>
    )
  }

  editarProcesso(processo){
    this.props.history.push(`/fichaProcesso/${processo.codigo}/SEARCH`);
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    const consultaIndice = LocalStorageService.obterConsulta('_consulta_processo_indice');
    const consultaIndiceJson = JSON.parse(consultaIndice);

    const consultaFiltro = LocalStorageService.obterConsulta('_consulta_processo_filtro');
    const consultaFiltroJson = JSON.parse(consultaFiltro);

    if(consultaIndiceJson != null) {
      await this.processoService.consultarProcessoPorIndice2(consultaIndiceJson)
        .then(response => {
          this.setState({processos: response.data});
          this.setState({partes: response.data.partes});
        }).catch(error => {
          this.setState(error.response.data)
          this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
        });
    }

    if(consultaFiltroJson != null) {
      await this.processoService.listarProcessos(consultaFiltroJson)
        .then(response => {
          this.setState({processos: response.data});
        }).catch(error => {
          this.setState(error.response.data)
          this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
        })
    }

    this.setState({openSpinner: false});
  }

  cadastrarProcesso =() => {
    this.props.history.push('/cadastrarProcesso')
  }

  templateConsultaProcesso(data) {
    var iconeImportante = '';
    var titleImportante = '';
    var iconeEstrategico = '';
    var titleEstrategico = '';
    var iconeFavorito = '';
    var titleFavorito = '';
    if(data.snImportante == 'S') {
      iconeImportante = 'p-button-rounded p-button-warning';
      titleImportante = 'Processo importante para empresa';
    } else {
      iconeImportante = 'p-button-rounded p-button-secondary';
      titleImportante = 'Processo não está classificado como importante para empresa';
    }

    if(data.estrategico == 'S') {
      iconeEstrategico = 'p-button-rounded p-button-info';
      titleEstrategico = 'Processo Estrategico';
    } else {
      iconeEstrategico = 'p-button-rounded p-button-secondary';
      titleEstrategico = '';
    }

    if(data.importanteParaMim == 'S') {
      iconeFavorito = 'p-button-rounded p-button-danger';
      titleFavorito = 'Processo classificado como meus favoritos';
    } else {
      iconeFavorito = 'p-button-rounded p-button-secondary';
      titleFavorito = '';
    }

    return(
      <div>
        <div className="row" style={{padding: '16px'}}>
          <div className="col-sm-3">
            <div className="form-group">
              Resumo
              <hr></hr>
              <div>
                <h4 style={{color: '#348DFF', fontSize: '14px', fontWeight: 'bold'}}><label style={{color: '#495357', display: 'inline'}}>Código:&nbsp;</label> {data.codigo}</h4>
                <h4 style={{color: '#348DFF', fontSize: '14px', fontWeight: 'bold', display: 'inline'}}><label style={{color: '#495357', display: 'inline'}}>CNJ:&nbsp;</label> {data.nrCnj}</h4>
                <h4 style={{color: '#348DFF', fontSize: '14px', fontWeight: 'bold'}}><label style={{color: '#495357', display: 'inline'}}>N. Processo:&nbsp;</label> {data.nrProcesso}</h4>
                <h4 style={{color: '#348DFF', fontSize: '14px', fontWeight: 'bold'}}><label style={{color: '#495357', display: 'inline'}}>Pasta:&nbsp;</label> {data.pasta}</h4>
                <h4 style={{color: '#348DFF', fontSize: '14px', fontWeight: 'bold'}}><label style={{color: '#495357', display: 'inline'}}>Grupo Trabalho:&nbsp;</label>{data.grupoTrabalho.nome}</h4>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="form-group">
              Partes
              <hr></hr>
              <div>
                <DataTable value={data.partes} 
                              emptyMessage=" "
                              size="small"
                              className="teste1 teste2"
                              showGridlines>
                    <Column field="parteNomeTipo"></Column>
                </DataTable>
              </div>
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              Responsável/Dt. Cadastro/ Área/Status Processual
              <hr></hr>
              <div>
                <h4 style={{color: '#495357', fontSize: '14px', fontWeight: 'bold'}}> 
                <i className="pi pi-user" style={{ fontSize: '1rem' }}></i>&nbsp;&nbsp;{data.responsavel.nome}</h4>
                <h4 style={{color: '#495357', fontSize: '14px', fontWeight: 'bold'}}> 
                <i className="pi pi-calendar" style={{ fontSize: '1rem' }}></i>&nbsp;&nbsp;{data.dataCadastro}</h4>
                <h4 style={{color: '#495357', fontSize: '14px', fontWeight: 'bold'}}>{data.areaAtuacao.nome}</h4>
                <h4 style={{color: '#495357', fontSize: '14px', fontWeight: 'bold'}}>{data.statusProcessual.descricao}</h4>
              </div>
            </div>
          </div>
          <div className="col-sm-2">
            <div className="form-group">
              Ações
              <hr></hr>
              <div style={{paddingTop: '50px'}}>
                <a onClick={() => this.editarProcesso(data)}
                   title="Abrir Processo" 
                   className="cursor">
                  <i className="pi pi-search" style={{ fontSize: '2rem' }}></i>    
                </a>
                &nbsp;&nbsp;&nbsp;
                <a onClick={() => this.opcaoExcluir(data)}
                   title="Excluir Processo"
                   className="cursor">
                  <i className="pi pi-trash" style={{ fontSize: '2rem' }}></i>    
                </a>
              </div>
            </div>
          </div>
        </div>
        <hr></hr>
      </div>
    );
  }

  templatePartes(data) {
    return(
      <div>
        {data.pessoa.nome}
      </div>
    );
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
              <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="fas fa-balance-scale"></i>
                          <span> Processos e Casos</span>
                        </h3>  
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-5">
														<div className="p-inputgroup flex-1">
															<button type="button" className="btn btn-primary bg-gradient-primary" 
																				onClick={this.cadastrarProcesso} 
																				aria-haspopup aria-controls="overlay_panel">
																<i className="fas fa-plus"></i> Adicionar</button>
																&nbsp;
																<button type="button" className="btn btn-info bg-gradient-info" 
																				data-toggle="modal" 
																				title="Filtro Avançado"
																				onClick={(e) => this.op.toggle(e)} 
																				aria-haspopup aria-controls="overlay_panel">
																<i className="fas fa-filter"></i></button>

																<OverlayPanel ref={(el) => this.op = el} showCloseIcon id="overlay_panel" 
																							style={{width: '750px'}} 
																							className="overlaypanel-demo"
																							onShow={this.carregaCombosConsulta}>

																	<div className="row">
																		<div className="col-sm-6">
																			<div className="form-group">
																				<label>Pessoa</label>
																				<InputText id="consultaPessoa" 
																									type="text" 
																									style={{width: '100%'}} 
																									value={this.state.pessoa}
																									onChange={e => this.setState({pessoa: e.target.value})}
																									className="p-inputtext-sm p-d-block p-mb-1"/>
																			</div>
																		</div>
																		<div className="col-sm-6">
																			<div className="form-group">
																				<label>Pasta</label>
																				<InputText id="pastaConsultas" 
																									type="text" 
																									style={{width: '100%'}} 
																									value={this.state.pasta}
																									onChange={e => this.setState({pasta: e.target.value})}
																									className="p-inputtext-sm p-d-block p-mb-1"/>
																			</div>
																		</div>
																	</div>
																	<div className="row">
																		<div className="col-sm-6">
																			<div className="form-group">
																				<label>Número CNJ</label>
																				<InputText id="cnjConsulta" 
																									type="text" 
																									style={{width: '100%'}} 
																									value={this.state.numeroCnj}
																									onChange={e => this.setState({numeroCnj: e.target.value})}
																									className="p-inputtext-sm p-d-block p-mb-1"/>
																			</div>
																		</div>
																		<div className="col-sm-6">
																			<div className="form-group">
																				<label>Número Processo</label>
																				<InputText id="numeroProcessoConsulta" 
																									type="text" 
																									style={{width: '100%'}} 
																									value={this.state.numeroProcesso}
																									onChange={e => this.setState({numeroProcesso: e.target.value})}
																									className="p-inputtext-sm p-d-block p-mb-1"/>
																			</div>
																		</div>
																	</div>
																	<div className="row">
																		<div className="col-sm-6">
																			<div className="form-group">
																				<label>Grupo de Trabalho</label>
																				<Dropdown value={this.state.grupoTrabalho} 
																						options={this.state.gruposTrabalho} style={{width: '100%'}}
																						optionLabel="nome" 
																						filter showClear filterBy="nome"
																						onChange={this.onGrupoChange}
																						id="grupoConsulta"
																						className="p-inputtext-sm p-d-block p-mb-1"/>
																			</div>
																		</div>
																		<div className="col-sm-6">
																			<div className="form-group">
																				<label>Tipos de Ação</label>
																				<Dropdown value={this.state.tipoAcao} 
																						options={this.state.tiposAcao} style={{width: '100%'}}
																						optionLabel="nome" 
																						filter showClear filterBy="nome"
																						onChange={this.onTiposAcaoChange}
																						id="tipoAcaoConsulta"
																						className="p-inputtext-sm p-d-block p-mb-1"/>
																			</div>
																		</div>
																	</div>
																	<div className="row">
																		<div className="col-sm-6">
																			<div className="form-group">
																				<label>Status Processual</label>
																				<Dropdown value={this.state.statusProcessual} 
																						options={this.state.statusProcessuais} style={{width: '100%'}}
																						optionLabel="descricao" 
																						filter showClear filterBy="descricao"
																						onChange={this.onStatusProcessualChange}
																						id="statusProcessualConsulta"
																						className="p-inputtext-sm p-d-block p-mb-1"/>
																			</div>
																		</div>
																		<div className="col-sm-6">
																			<div className="form-group">
																				<label>Tipos de Decisão</label>
																				<Dropdown value={this.state.tipoDecisao} 
																						options={this.state.tiposDecisao} style={{width: '100%'}}
																						optionLabel="nome" 
																						filter showClear filterBy="nome"
																						onChange={this.onTiposDecisaoChange}
																						id="tiposDecisapConsulta"
																						className="p-inputtext-sm p-d-block p-mb-1"/>
																			</div>
																		</div>
																	</div>
																	<div className="row">
																		<div className="col-sm-4">
																			<div className="formGroup">
																				<label>
																				<Checkbox inputId="importanteParaMim" 
																									checked={this.state.importanteParaMim}
																									onChange={e => this.setState({ importanteParaMim: e.checked })} />
																									&nbsp;&nbsp;Importante para mim</label>
																			</div>
																		</div>
																		<div className="col-sm-4">
																			<div className="formGroup">
																				<label>
																				<Checkbox inputId="importanteParaEmpresa" 
																									checked={this.state.importanteParaEmpresa}
																									onChange={e => this.setState({ importanteParaEmpresa: e.checked })} />
																									&nbsp;&nbsp;Importante para empresa</label>
																			</div>
																		</div>
																		<div className="col-sm-4">
																			<div className="formGroup">
																				<label>
																				<Checkbox inputId="estrategico" 
																									checked={this.state.estrategico}
																									onChange={e => this.setState({ estrategico: e.checked })} />
																									&nbsp;&nbsp;Estratégico</label>
																			</div>
																		</div>
																	</div>
																	<div className="direita">
																		<button type="submit" className="btn btn-success" onClick={this.listarProcessos}>
																			<i className="fas fa-check"></i>
																			&nbsp;Aplicar
																		</button>
																	</div>
																	
																</OverlayPanel>
																&nbsp;
																
																	<InputText placeholder="Consulte um processo... Pasta, Autor, Réu, CNJ"
																						value={this.state.indice}
																						onChange={e => this.setState({indice: e.target.value})}
																						onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}/>
																	<Button icon="pi pi-search" 
																					onClick={this.consultarProcessoPorIndice}
																					className="p-button-primary" />
																
														</div>
                          </div>
                        </div>
                        
                        <Backdrop
                          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                          open={this.state.openSpinner}>
                          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                        </Backdrop>

                      </div>
                      <div className="card">
                        <DataView value={this.state.processos} 
                                  emptyMessage=" "
                                  itemTemplate={this.templateConsultaProcesso} />
                      </div>

                       {/**Opções de exclusão de um processo */}
                       <Dialog header="Exclusão de Processo"
                                  visible={this.state.modalExclusao} 
                                  footer={this.renderFooterExclusao('modalExclusao')}
                                  onHide={() => this.fecharModal('modalExclusao')}>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <h4>
                                    <strong style={{color: 'blue'}}>Selecione um tipo de exlusão</strong>
                                  </h4>
                                </div>  
                              </div>
                            </div>
                            <br></br>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <div className="row">
                                    <RadioButton inputId="tipoExclusaoLixeira" 
                                                 name="tipoExclusaoLixeira" 
                                                 value="lixeira" 
                                                 onChange={e => this.setState({tipoExclusao: e.target.value})} 
                                                 checked={this.state.tipoExclusao === 'lixeira'} />
                                    &nbsp;&nbsp;
                                    <label htmlFor="tipoExclusaoLixeira">Remover para lixeira</label>
                                    &nbsp;&nbsp;
                                    <RadioButton inputId="tipoExclusaoDefinitivo" 
                                                 name="tipoExclusaoDefinitivo" 
                                                 value="definitivo" 
                                                 onChange={e => this.setState({tipoExclusao: e.target.value})} 
                                                 checked={this.state.tipoExclusao === 'definitivo'} />
                                    &nbsp;&nbsp;
                                    <label htmlFor="tipoExclusaoDefinitivo">Excluir Definitivamente</label>
                                  </div>
                                  
                                </div>
                              </div>
                            </div>
                      </Dialog>
                      {/**Avisio de exclusão em definitivo */}
                      <Dialog header="Exclusão de Processo"
                                  visible={this.state.modalAvisoDefinitivo} 
                                  style={{ width: '30vw' }} 
                                  footer={this.renderFooterAvisoExclusao('modalAvisoDefinitivo')}
                                  onHide={() => this.fecharModal('modalAvisoDefinitivo')}>
                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <div style={{textAlign: 'center', justifyContent: 'center', alignItems: 'center'}}>
                                    <img src={warning} alt="iLaw Gestão" style={{width: '20%'}} />
                                  </div>
                                  <br></br>
                                  <p>
                                    <h5>
                                    Ao optar por excluir em definitivo, além do processo, todas as atividades, históricos,
                                    lancamentos financeiros, pagamentos e custas serão excluídos também.
                                    Esta ação é irreversível, confirma a exlusão mesmo assim ?</h5>
                                  </p>
                                </div>
                              </div>
                            </div>
                      </Dialog>
                    </div>
                  </div>
                </div>
              </div>
            </section>
        </div>
      </>
    )
  }
}

Processo.contextType = AuthContext;
export default withRouter(Processo)